import { render, staticRenderFns } from "./SubscribeFormSubmissionForm.vue?vue&type=template&id=4821e708&scoped=true"
import script from "./SubscribeFormSubmissionForm.vue?vue&type=script&lang=js"
export * from "./SubscribeFormSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821e708",
  null
  
)

export default component.exports